import { context } from '@wikia/ad-engine';

export function getVerizonContext(): object {
	return {
		enabled: false,
		dcn: '8a96945901757509a7551e039e180357',
		slots: {
			top_leaderboard: {
				sizes: [[728, 90]],
				pos: 'top_leaderboard',
			},
			top_boxad: {
				sizes: [[300, 250]],
				pos: 'top_boxad',
			},
			incontent_boxad: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.incontent_boxad ?? [
					[300, 250],
					[300, 1050],
				],
				pos: 'incontent_boxad',
			},
			bottom_leaderboard: {
				sizes: [[728, 90]],
				pos: 'bottom_leaderboard',
			},
		},
	};
}
